import axios from 'axios'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
const api = axios.create({
  baseURL: API_ENDPOINT,
  timeout: 10000
})

export async function getBens (segmento) {
  const params = {
    tipoGrupo: segmento,
    convenio: '1',
    'gw-dev-app-key': 'bbe5425359c42ac7967f54996d0018d9'
  }
  const res = await api.get('/bens', { params })
  return res
}

export async function getPlanos (
  tipoGrupo,
  codigoProdutor,
  codigoBem,
  valorBem,
  mesPlanoInicio = 1,
  mesPlanoFim = 100,
  convenio = 1
) {
  let data = {
    tipoGrupo: tipoGrupo,
    codigoProdutor: codigoProdutor,
    codigoBem: codigoBem,
    valorBem: valorBem,
    mesPlanoInicio: mesPlanoInicio,
    mesPlanoFim: mesPlanoFim,
    convenio: convenio
  }
  const params = {
    'gw-dev-app-key': 'bbe5425359c42ac7967f54996d0018d9'
  }
  const headers = {
    'Content-Type': 'application/json'
  }
  const res = await api.post('/listar-planos', data, { params, headers })
  return res
}
